import { WindowTitle } from "@saleor/components/WindowTitle";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, Routes, useLocation } from "react-router-dom";

import ProductStocksListComponent from "./views/ProductStockList";
const ProductStocksList: React.FC = () => {
  const location = useLocation();
  const params = parseQs(location.search.substr(1));

  return <ProductStocksListComponent params={params} />;
};

const Component = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle
        title={intl.formatMessage({
          defaultMessage: "Product Stocks",
          description: "product stocks report section name"
        })}
      />

      <Routes>
        <Route path={""} element={<ProductStocksList />} />
      </Routes>
    </>
  );
};

export default Component;
